import { render, staticRenderFns } from "./TextCharacterProperties.vue?vue&type=template&id=6538f940&scoped=true"
import script from "./TextCharacterProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextCharacterProperties.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextCharacterProperties.vue?vue&type=style&index=0&id=6538f940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6538f940",
  null
  
)

export default component.exports